import React, { FC } from 'react';
import styles from './excerpt_related.module.scss';

export const ExcerptRelated: FC = ({ children }) => {
  return <div className={styles.container}>{children}</div>;
};
